import styled from 'styled-components';
import { ReactComponent as RawExternalLinkSVG } from '../../../../assets/icons/external_link.svg';

export const IconExternalLink = styled(RawExternalLinkSVG)``;
